<template>
  <div :key="refresh">
    <v-container class="pt-2 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <div class="d-flex flex-start">
              <router-link class="sm-fullwidth" :to="{ name: 'Home' }">
                <v-btn color="primary-dark" block class="sm-fullwidth mt-2" variant="default" size="small"> <v-icon
                    icon="mdi-arrow-left-bold"></v-icon> Retour à l'accueil </v-btn>
              </router-link>
            </div>
            <div class="text-h4 text-center font-weight-bold my-2 text-darkblue">Interface d'administration du module
            </div>
            
            <div v-if="mainStore.authAdmin.isLogged">
  
              <div v-if="mainStore.authAdmin.hasModuleAccess">
                <Administration_Dashboard v-if="mainStore.authAdmin.hasAdminRights"></Administration_Dashboard>
                <Verificateur_Dashboard v-if="mainStore.authAdmin.hasVerificateurRights"></Verificateur_Dashboard>
              </div>
              <AdministrationWrongPrivileges v-else></AdministrationWrongPrivileges>
            </div>
            <div v-else>
              <v-container fluid class="px-3">
                <v-row no-gutters>
                  <v-col offset-md="3" md="6" cols="12">
                    <AdminLogin class="pa-2"></AdminLogin>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminLogin from "@/components/Authentification/AdminLoginForm.vue";
import Administration_Dashboard from "@/components/Administration/Administration_Dashboard.vue";
import Verificateur_Dashboard from "@/components/Administration/Verificateur_Dashboard.vue";

import AdministrationWrongPrivileges from "@/components/Administration/AdministrationWrongPrivileges.vue";
export default {
  components: { Administration_Dashboard, AdministrationWrongPrivileges, AdminLogin, Verificateur_Dashboard },
  data() {
    return {
      refresh: 0,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  watch: {
    "mainStore.authAdmin.adminData": function () {
      this.refresh++;
    },
  },
};
</script>

<style lang="scss" scoped></style>